import React from "react";
import LandingHeaderContainer from "./header/header-container";
import Pages from "./pages/pages";
import s from "./landing-page.module.scss";

const LandingPage = (props) => {

    return (
        <div className={s.LandingPage}>
            <LandingHeaderContainer />
            <Pages 
                getValue={props.getValue} 
                activeMenu={props.activeMenu} 
                signin={props.signin} 
                demoMenu={props.demoMenu}
                demoContent={props.demoContent}
                setIsShowDemo={props.setIsShowDemo}
                isShowDemo={props.isShowDemo}
                showModal={props.modalShowToggle}
                loginError={props.loginError}
                errorInRegistration={props.errorInRegistration}
                setErrorInLogin={props.setErrorInLogin}
                mediaBlocks={props.mediaBlocks}
                advantagesMenu={props.advantagesMenu}
                sendMessage={props.sendMessage}
                isDemoSuccess={props.isDemoSuccess}
                setIsDemoSuccess={props.setIsDemoSuccess}
                resetPassword={props.resetPassword}
                setErrorInResetPassword={props.setErrorInResetPassword}
                situableBlocks={props.situableBlocks}
                setMenuActive={props.setMenuActive}
                errorInResetPassword={props.errorInResetPassword}
                selectedLanguage={props.selectedLanguage}
                authLanguage={props.authLanguage}
                //modalShowToggle={props.modalShowToggle}
            />
        </div>
    )
}

export default LandingPage;